"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiContactButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MuiButton = _interopRequireDefault(require("../MuiButton/MuiButton"));

var _customProps = require("../../utils/customProps");

var MuiContactButton = function MuiContactButton(_ref) {
  var button = _ref.button,
      phone = _ref.phone,
      email = _ref.email;
  var muibutton = button[0];

  var onClick = function onClick() {
    var tempLink = document.createElement('a');

    if (phone) {
      tempLink.href = "tel: ".concat(+phone);
    } else if (email) {
      tempLink.href = "mailto: ".concat(email);
    }

    tempLink.click();
    tempLink.remove();
  };

  return /*#__PURE__*/_react.default.createElement(_MuiButton.default, (0, _extends2.default)({}, muibutton, {
    onClick: onClick
  }));
};

exports.MuiContactButton = MuiContactButton;
var _default = MuiContactButton;
exports.default = _default;
MuiContactButton.propTypes = {
  /** Telephone number provided to call */
  phone: _propTypes.default.string,

  /** Email address provided to email to */
  email: _propTypes.default.string,

  /** MuiButton Allowed maximum: 1 */
  button: function button(props, propName, componentName) {
    var components = ['MuiButton'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
MuiContactButton.defaultProps = {
  phone: '',
  email: '',
  button: []
};